import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../Components/Firebase";
import Logo1 from "../Images/Milaaz1.png";
import '../Styles/Auth/Login.css';
import { useNavigate } from "react-router-dom";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  const nav = useNavigate();

  const translateFirebaseError = (code) => {
    const messages = {
      "auth/invalid-email": "כתובת האימייל אינה תקינה.",
      "auth/user-disabled": "החשבון הזה הושבת.",
      "auth/user-not-found": "לא נמצא משתמש עם האימייל הזה.",
      "auth/wrong-password": "הסיסמה שגויה.",
      "auth/too-many-requests": "יותר מדי ניסיונות כושלים. נסה שוב מאוחר יותר.",
    };
    return messages[code] || "אירעה שגיאה לא ידועה. נסה שוב.";
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      nav(`/CheckUser/${user.uid}`);
    } catch (err) {
      setError(translateFirebaseError(err.code));
    }
  };

  return (
    <div className="login-container" dir="rtl">
      <form onSubmit={handleLogin} className="login-form">
        <img
          src={Logo1}
          alt="לוגו"
          className="login-logo"
          onContextMenu={(e) => e.preventDefault()}
          onDragStart={(e) => e.preventDefault()}
        />
        <h2>התחברות</h2>
        {error && <p className="login-error">{error}</p>}
        <input
          type="email"
          placeholder="אימייל"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="סיסמה"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit">התחבר</button>
      </form>
    </div>
  );
}

export default Login;
